import { ASSIGNEE_UNASSIGNED } from "@/components/ui/filters/filterHandlers";
import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const DEBOUNCE_DELAY = 500; // milliseconds
const UNASSIGNED_LABEL = "Unassigned";

type AssigneeFilterProps = {
  field: string;
  label: string;
  value: string; // "" | "<username>" | ASSIGNEE_UNASSIGNED
  onChange: (field: string, value: string) => void;
};

export function AssigneeFilter({
  field,
  label,
  value,
  onChange,
}: AssigneeFilterProps) {
  const display = value === ASSIGNEE_UNASSIGNED ? UNASSIGNED_LABEL : value;
  const [inputValue, setInputValue] = useState(display);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    setInputValue(display);
  }, [display]);

  const emitDebounced = (text: string) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onChange(field, text);
    }, DEBOUNCE_DELAY);
  };

  return (
    <Autocomplete
      freeSolo
      size="small"
      options={[UNASSIGNED_LABEL]}
      inputValue={inputValue}
      onInputChange={(_, newInput, reason) => {
        setInputValue(newInput);
        if (reason === "input") {
          emitDebounced(newInput);
        } else if (reason === "clear") {
          clearTimeout(timerRef.current);
          onChange(field, "");
        }
      }}
      onChange={(_, selected) => {
        clearTimeout(timerRef.current);
        if (selected === UNASSIGNED_LABEL) {
          onChange(field, ASSIGNEE_UNASSIGNED);
        } else {
          onChange(field, selected ?? "");
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} sx={{ minWidth: 180 }} />
      )}
    />
  );
}
